import { HeaderFixed } from '@/components';
import { JarFilterButtons } from './JarFilterButtons';
import { JarSearchBox } from './JarSearchBox';
import { css, cx } from '@emotion/css';
import { useEffect, useState } from 'react';
import { useScroll, useMotionValueEvent } from 'framer-motion';

export const JarHeader: React.FC = () => {
  const { scrollY } = useScroll();
  const [hasShadow, setHasShadow] = useState(false);

  useEffect(() => {
    setHasShadow(scrollY.get() > 0);
  }, [scrollY]);

  useMotionValueEvent(scrollY, 'change', latest => {
    const shouldShowShadow = latest > 0;
    if (shouldShowShadow !== hasShadow) {
      setHasShadow(shouldShowShadow);
    }
  });

  return (
    <HeaderFixed className={cx(hasShadow && cn.shadow)}>
      <JarSearchBox />
      <JarFilterButtons />
    </HeaderFixed>
  );
};

const cn = {
  shadow: css`
    box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2);
  `,
};
